module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "main-sidebar"
  }, [_c('section', {
    staticClass: "sidebar"
  }, [_c('div', {
    staticClass: "user-panel"
  }, [_c('div', {
    staticClass: "image"
  }, [(!_vm.is90d) ? _c('img', {
    staticClass: "img-circle",
    attrs: {
      "src": "/static/img/avatar2.png",
      "alt": "User Image"
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('p'), _vm._v(" "), _c('div', [_c('a', {
    on: {
      "click": function($event) {
        return _vm.logout()
      }
    }
  }, [_c('i', {
    staticClass: "ti-power-off"
  }), _c('small', [_vm._v("Logout")])])])]), _vm._v(" "), _c('img', {
    staticClass: "bg-user",
    attrs: {
      "src": "/static/img/avatar-bg.png",
      "alt": "User Image"
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "sidebar-menu"
  }, [_c('li', {
    staticClass: "treeview"
  }, [_c('router-link', {
    attrs: {
      "to": "/admin/publishers/"
    }
  }, [_c('span', {
    staticClass: "svg-icon"
  }, [_c('i', {
    staticClass: "fa fa-users",
    staticStyle: {
      "font-size": "17px"
    },
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Publishers")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right-container"
  })])], 1), _vm._v(" "), _c('li', {
    staticClass: "treeview"
  }, [_c('router-link', {
    attrs: {
      "to": "/admin/domains/"
    }
  }, [_c('span', {
    staticClass: "svg-icon"
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-globe fa-w-16",
    attrs: {
      "aria-hidden": "true",
      "width": "20px",
      "height": "20px",
      "data-prefix": "fal",
      "data-icon": "globe",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 496 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm193.2 152h-82.5c-9-44.4-24.1-82.2-43.2-109.1 55 18.2 100.2 57.9 125.7 109.1zM336 256c0 22.9-1.6 44.2-4.3 64H164.3c-2.7-19.8-4.3-41.1-4.3-64s1.6-44.2 4.3-64h167.4c2.7 19.8 4.3 41.1 4.3 64zM248 40c26.9 0 61.4 44.1 78.1 120H169.9C186.6 84.1 221.1 40 248 40zm-67.5 10.9c-19 26.8-34.2 64.6-43.2 109.1H54.8c25.5-51.2 70.7-90.9 125.7-109.1zM32 256c0-22.3 3.4-43.8 9.7-64h90.5c-2.6 20.5-4.2 41.8-4.2 64s1.5 43.5 4.2 64H41.7c-6.3-20.2-9.7-41.7-9.7-64zm22.8 96h82.5c9 44.4 24.1 82.2 43.2 109.1-55-18.2-100.2-57.9-125.7-109.1zM248 472c-26.9 0-61.4-44.1-78.1-120h156.2c-16.7 75.9-51.2 120-78.1 120zm67.5-10.9c19-26.8 34.2-64.6 43.2-109.1h82.5c-25.5 51.2-70.7 90.9-125.7 109.1zM363.8 320c2.6-20.5 4.2-41.8 4.2-64s-1.5-43.5-4.2-64h90.5c6.3 20.2 9.7 41.7 9.7 64s-3.4 43.8-9.7 64h-90.5z"
    }
  })])]), _vm._v(" "), _c('span', [_vm._v("Domains")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right-container"
  })])], 1), _vm._v(" "), _vm._l((_vm.navigation), function(nav) {
    return _c('li', {
      key: nav.name,
      staticClass: "treeview"
    }, [(
      (nav.path && nav.path.indexOf('dfp-settings') == -1) ||
      (nav.path && nav.path.indexOf('dfp-settings') > -1 && _vm.hasAccess)
    ) ? _c('router-link', {
      attrs: {
        "to": ("" + (nav.path))
      }
    }, [(!nav.isSvg) ? _c('i', {
      class: ("" + (nav.icon))
    }) : _vm._e(), _vm._v(" "), (nav.isSvg) ? _c('span', {
      staticClass: "svg-icon",
      domProps: {
        "innerHTML": _vm._s(nav.icon)
      }
    }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(nav.name))]), _vm._v(" "), (nav.modules.length) ? _c('span', {
      staticClass: "pull-right-container"
    }, [_c('i', {
      staticClass: "fa fa-angle-left pull-right"
    })]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!nav.path) ? _c('a', {
      attrs: {
        "href": "javascript:void(0);"
      }
    }, [(!nav.isSvg) ? _c('i', {
      class: ("" + (nav.icon))
    }) : _vm._e(), _vm._v(" "), (nav.isSvg) ? _c('span', {
      staticClass: "svg-icon",
      domProps: {
        "innerHTML": _vm._s(nav.icon)
      }
    }) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "products-name"
    }, [_vm._v(_vm._s(nav.name))]), _vm._v(" "), (nav.modules.length) ? _c('span', {
      staticClass: "pull-right-container"
    }, [_c('i', {
      staticClass: "fa fa-angle-left pull-right"
    })]) : _vm._e()]) : _vm._e(), _vm._v(" "), (nav.modules.length) ? _c('ul', {
      staticClass: "treeview-menu sidebar-menu",
      staticStyle: {
        "display": "block"
      }
    }, _vm._l((nav.modules), function(module, index) {
      return (_vm.isNavigationAllowed(module)) ? _c('li', {
        key: index,
        staticClass: "treeview",
        class: module.link === _vm.currentPath ? 'active' : ''
      }, [_c('router-link', {
        attrs: {
          "to": ("" + (module.link))
        }
      }, [_c('div', {
        staticClass: "vue-avatar--wrapper"
      }, [_c('span', [_c('img', {
        staticClass: "round",
        attrs: {
          "width": "20",
          "height": "20",
          "avatar": ("" + (module.name))
        }
      })])]), _vm._v("\n                            " + _vm._s(module.name) + "\n                        ")])], 1) : _vm._e()
    }), 0) : _vm._e()], 1)
  }), _vm._v(" "), _c('li', {
    staticClass: "treeview"
  }, [_c('router-link', {
    attrs: {
      "to": "/admin/bidders/"
    }
  }, [_c('span', {
    staticClass: "svg-icon"
  }, [_c('i', {
    staticClass: "fa fa-users",
    staticStyle: {
      "font-size": "17px"
    },
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Bidders")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right-container"
  })])], 1)], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5033b7ff!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/Sidebar.vue
// module id = 691
// module chunks = 2